// 导入所有组件
import SgpForm from './form'
import SgpTable from './table'
import SgpButton from './button'
import SgpDialog from './dialog'
import SgpBreadcrumb from './breadcrumb'
import SgpTitle from './title'
// 导入更多组件...

// 组件列表
const components = [
  SgpForm,
  SgpTable,
  SgpButton,
  SgpDialog,
  SgpBreadcrumb,
  SgpTitle
]

// 定义 install 方法
const install = function (Vue, options = {}) {
  // 全局配置
  const { size } = options

  // 设置 Element UI 配置（如果传递了配置）
  if (size) {
    Vue.prototype.$ELEMENT = { size }
  }

  // 注册所有组件
  components.forEach(component => {
    Vue.component(component.name, component)
  })
}

// 自动安装（通过 script 标签引入时）
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

// 导出所有组件
export {
  SgpForm,
  SgpTable,
  SgpButton,
  SgpDialog,
  SgpBreadcrumb,
  SgpTitle
}

// 导出 install 方法
export default {
  version: '1.0.0',
  install,
  SgpForm,
  SgpTable,
  SgpButton,
  SgpDialog,
  SgpBreadcrumb,
  SgpTitle
}
